import type DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import { type GroupFolderWellKnownName } from './GroupFolderConstants';

// Supported folders in Unified Inbox
export const UnifiedInboxSupportedFolders: DistinguishedFolderIdName[] = [
    'inbox',
    'drafts',
    'outbox',
    'archive',
    'sentitems',
    'scheduled',
    'deleteditems',
    'junkemail',
];
